import { Flex, Icon, PageHeader, Separator, Tabs } from '@driftt/dds'
import { faSparkles } from '@driftt/dds.icons/solid/faSparkles'
import { Subnav } from '@driftt/tide-subnav'
import React from 'react'
import { useState } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'

import GuardrailsTable from 'components/GuardrailsTable'
import { APP_PAGE_TITLES } from 'constants/pageTitles'
import useDocumentTitle from 'hooks/usePageTitle'
import { userHasAnyPlaybookAccess } from 'utils/access'
import { getSubNavNodes } from 'utils/getSubNavNodes'

const GuardrailsTabPage = ({ history }: RouteComponentProps) => {
  const [sidebarIsOpen, setSidebarIsOpen] = useState(true)
  const [activeTab, setActiveTab] = useState('Active')
  const hasAnyPlaybookAccess = userHasAnyPlaybookAccess()
  useDocumentTitle(APP_PAGE_TITLES.GUARDRAIL)
  const SUB_NAV_NODES = getSubNavNodes()

  return (
    <>
      {hasAnyPlaybookAccess && (
        <Subnav
          title="Chatbot"
          nodes={SUB_NAV_NODES}
          open={sidebarIsOpen}
          onToggle={() => setSidebarIsOpen(!sidebarIsOpen)}
        />
      )}
      <PageHeader.Root>
        <Flex
          direction="column"
          css={{
            paddingTop: '$2',
            minHeight: 0, // allow shrinking
            overflow: 'auto' // enable scrolling if needed
          }}
          fullHeight
        >
          <PageHeader.Main>
            <PageHeader.Title>
              <Icon
                size="large"
                icon={faSparkles}
                color="purple7"
                css={{ verticalAlign: 'baseline', marginRight: '$1' }}
              />
              Guardrails
            </PageHeader.Title>
            <PageHeader.Subtitle>
              Safeguards to ensure Drift AI stays on track and aligned with your
              goals
            </PageHeader.Subtitle>
          </PageHeader.Main>
          <Tabs
            onValueChange={setActiveTab}
            options={[
              {
                content: <GuardrailsTable activeTab={activeTab} />,
                label: 'Active',
                value: 'active',
              },
              {
                content: <GuardrailsTable activeTab={activeTab} />,
                label: 'Archived',
                value: 'archive',
              },
            ]}
            tabListProps={{
              css: {
                paddingLeft: '$4',
                paddingRight: '$4',
                marginBottom: '0',
                background: '$white',
              },
            }}
          />
          <Separator />
        </Flex>
      </PageHeader.Root>
    </>
  )
}

export default withRouter(GuardrailsTabPage)
